import { defineStore } from 'pinia';
import Session from '@/models/session.model';
import Jwt from '@/models/jwt.model';
import { useRootStore } from './root.store';

export const useUserStore = defineStore('user', {
  state: () => ({
    session: Session.fromCookies(),
    user: null,
  }),

  getters: {
    hasSession() {
      return !!this.session && !!this.session?.isAuthenticated;
    },
    isAuthenticated() {
      return this.hasSession && !!this.user;
    },

    isPaper() {
      return this.hasSession && this.session.isPaper;
    },

    isLive() {
      return this.hasSession && this.session.isLive;
    },
  },

  actions: {
    async fetchUser() {
      if (!this.hasSession) throw new Error('No session available');
      if (this.user) return this.user;
      this.user = await this.session.createUser();
      return this.user;
    },

    loginFromJwt(jwt, expiry) {
      const jwtInstance = new Jwt(jwt);
      this.session = Session.loginFromJwt(jwtInstance, expiry);
      this.fetchUser();
    },

    async loginFromToken(token, environment) {
      this.session = Session.loginFromToken(token, environment);
      await this.fetchUser();
    },

    switchActiveAccount(account) {
      // if the account is already active, do nothing
      // if the account is not in the user list of accounts, do nothing
      // update the active account cookie
      // refresh the page
      console.log('switchActiveAccount()', account);
    },

    switchToPaperTrading(account, token) {
      // if account and token are not provided, throw an error
      if (!account || !token) throw new Error('Account and token are required');

      this.switchActiveAccount(account);
      this.session = Session.loginFromToken(token, 'sandbox', this.session.jwt);
      window.location.reload();
    },

    switchToLiveTrading() {
      // clear the active paper trading account cookie
      useRootStore().cookieService?.clearAccountCookie();
      // clear the paper trading token cookie
      useRootStore().cookieService?.clearAccessTokenCookie();
      // clear the environment cookie
      useRootStore().cookieService?.clearEnvironmentCookie();

      // refresh the page
      window.location.reload();
    },

    logout() {
      this.session?.logout();
      this.session = null;
      this.user = null;
    },
  },
});
